import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Heading, Text } from '@grandvisionhq/elements';
import { pushLoginAction, pushCheckedConsent, pushStartEyeTest, LaunchEyeExam } from '@grandvisionhq/eye-exam';
import { useIntl } from '@grandvisionhq/state';

const EyeExamSection = ({ className  })=>{
    const { getLabel  } = useIntl();
    const dataLayer = React.useMemo(()=>({
            onLogin: ()=>pushLoginAction('my prescription')
            ,
            onConsent: (hasConsent)=>hasConsent && pushCheckedConsent('my prescription')
            ,
            onStartEyeExam: ()=>pushStartEyeTest('my prescription')
        })
    , []);
    return /*#__PURE__*/ React.createElement("section", {
        className: classnames('eye-exam-section', className)
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "h2"
    }, getLabel('account.eyeExam.title')), /*#__PURE__*/ React.createElement(Text, null, getLabel('account.eyeExam.description')), /*#__PURE__*/ React.createElement(LaunchEyeExam, swcHelpers.extends({}, dataLayer)));
};

export { EyeExamSection };
//# sourceMappingURL=EyeExamSection.js.map
